import { bootstrapApplication } from '@angular/platform-browser';
import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaEnterpriseProvider, CustomProvider } from 'firebase/app-check';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

// ── App Check debug token must be set BEFORE initializeAppCheck ───────────
if (!environment.production &&
    environment.appCheckDebugToken &&
    environment.appCheckDebugToken !== 'REPLACE_WITH_DEBUG_TOKEN') {
  (self as any).FIREBASE_APPCHECK_DEBUG_TOKEN = environment.appCheckDebugToken;
  console.log(`App Check debug token active. Register in Firebase Console → App Check → Manage debug tokens.`);
}

// ── Initialize Firebase + App Check synchronously before bootstrap ────────
// AngularFireModule.initializeApp() and provideFirebaseApp() in app.config.ts
// will detect this existing [DEFAULT] app and reuse it — no duplicate-app error.
const firebaseApp = initializeApp(environment.firebaseConfig);

const isLocalhost = typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
const useEmulators = (environment as any).useEmulators === true;

// Skip App Check entirely in emulator mode
if (!useEmulators) {
  initializeAppCheck(firebaseApp, {
    provider: !isLocalhost && environment.recaptchaSiteKey
      ? new ReCaptchaEnterpriseProvider(environment.recaptchaSiteKey)
      : new CustomProvider({
          getToken: () => Promise.reject(new Error('Dev: App Check debug token active')),
        }),
    isTokenAutoRefreshEnabled: true,
  });
}

// Connect to emulators when running in emulator mode
if (useEmulators) {
  import('firebase/auth').then(({ getAuth, connectAuthEmulator }) => {
    connectAuthEmulator(getAuth(firebaseApp), 'http://localhost:9099', { disableWarnings: true });
  });
  import('firebase/firestore').then(({ getFirestore, connectFirestoreEmulator }) => {
    connectFirestoreEmulator(getFirestore(firebaseApp), 'localhost', 8080);
  });
  import('firebase/functions').then(({ getFunctions, connectFunctionsEmulator }) => {
    connectFunctionsEmulator(getFunctions(firebaseApp), 'localhost', 5001);
  });
  import('firebase/storage').then(({ getStorage, connectStorageEmulator }) => {
    connectStorageEmulator(getStorage(firebaseApp), 'localhost', 9199);
  });
  console.log('🔧 Firebase Emulators connected (auth:9099, firestore:8080, functions:5001, storage:9199)');
}

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));
